// The first-time "Before your shift" checklist (architecture sprint-14 §8.4). Shown once per person and browser
// (localStorage 'tt-sop-ack:<userId>') when they start a shift on an alarm project. It never blocks Start.
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { SOP_TITLE } from '@/content/shift-sop';
import { SopSteps } from './SopSteps';

interface SopChecklistDialogProps {
  open: boolean;
  onDone: () => void;
}

export function SopChecklistDialog({ open, onDone }: SopChecklistDialogProps): JSX.Element {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onDone()}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>{SOP_TITLE}</DialogTitle>
          <DialogDescription>Alarms ring in this tab during your shift. Check these once:</DialogDescription>
        </DialogHeader>
        <SopSteps />
        <div className="flex gap-2">
          <Button type="button" className="flex-1" onClick={onDone}>
            Got it
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
